// @flow
import {
  LOGIN_LOADING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  SIGNUP_SUCCESS,
  SIGNUP_ERROR,
  FETCH_ALL_ACCOUNTS_SUCCESS,
  FETCH_ALL_ACCOUNTS_ERROR,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATE_ACCOUNT_ERROR,
} from '../actions/accountActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case LOGIN_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        activeAccount: action.activeAccount,
        loginError: null,
      };
    case LOGIN_ERROR:
    case LOGOUT_ERROR:
      return {
        ...state,
        status: 'ERROR',
        loginError: action.error,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        activeAccount: null,
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        activeAccount: action.activeAccount,
        signupError: null,
      };
    case SIGNUP_ERROR:
      return {
        ...state,
        status: 'ERROR',
        signupError: action.error,
      };
    case FETCH_ALL_ACCOUNTS_SUCCESS:
      return {
        ...state,
        allAccounts: action.allAccounts,
      };
    case UPDATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        accountUpdated: true,
        accountError: null,
      };
    case FETCH_ALL_ACCOUNTS_ERROR:
    case UPDATE_ACCOUNT_ERROR:
      return {
        ...state,
        accountUpdated: false,
        accountError: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/accountReducer.js